// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__xcino","head":"ProcedureTableInfo_head__12enZ"};